import React, { useEffect, useState } from 'react'
import { useRef } from "react";
import { SpinWheelIcon } from "../../../../../styles/img/svg/SpinWheelIcon"
import { UiCol, UiRowContainer, UiSingleContainer, UiSingleRow } from "../../../components/grid-container/GridContainer"
import { UiButtonPrimary, UiButtonSecondary } from "../../../components/form/UiButton"
import RightCircleIcon from "../../../../../styles/img/svg/RightCircleIcon"
import { UiInput } from "../../../../_uiMocks/components/form/UiInput"
import ProgressBar from 'react-bootstrap/ProgressBar';
import { WheelOfFunIcon } from "../../../../../styles/img/svg/WheelOfFun"
import Winwheel from "winwheel";
import Pointer from '../../../../../styles/img/wheel-center.png'
import ConfettiExplosion from 'react-confetti-explosion';
import CircleRoundedGreen from "../../../../../styles/img/svg/CircleRoundedGreen"
import { PlusIcon } from "../../../../../styles/img/svg/PlusIcon";
import { Accordion } from "react-bootstrap";
import {
    UiContentWr,
    UiContentCol,
    UiContentWheelCol,
} from "../../../../_uiComponents/common/UiPageElements";
import { Form } from "react-final-form";
import Validator from "../../../../../_helpers/validate.schema";
import {
    campaignTokenValidationRequest,
    campaignSpinwinGetDataRequest,
    campaignSpinwinGetInitialDataRequest,
    spinWheelTokenReset,
} from "../../../../../_redux/_actions";

import WheelIndicator from "../../../../../styles/img/wheel-indicator.png";
// import CloseIcon from "../../../../styles/img/close-white-icon.png";

// const confetti = require('canvas-confetti');

// export default function SpinAndWheel(props) {
//     const headerRef = useRef();

//     const [points, setPoints] = useState(0);
//     const [congratBanner, setCongratBanner] = useState(false);
//     const [isExploding, setIsExploding] = React.useState(false);


//     useEffect(() => {
//         window.winwheel = new Winwheel({
//             canvasId: "canvas",
//             numSegments: 9,
//             'textMargin': 60,
//             'pins':
//             {
//                 'fillStyle': '#E5B449',
//                 'outerRadius': 8,
//                 'strokeStyle': '#fff',
//                 'margin': 170,
//                 'number': 9,
//                 'lineWidth': 4
//             },
//             segments: [
//                 { fillStyle: "#A32331", textFillStyle: '#ffff', textFontSize: '38', text: "5K" },
//                 { fillStyle: "#323232", textFillStyle: '#ffff', textFontSize: '38', text: "1K" },
//                 { fillStyle: "#599EDD", textFillStyle: '#ffff', textFontSize: '38', text: "100" },
//                 { fillStyle: "#7D3585", textFillStyle: '#ffff', textFontSize: '38', text: "50" },
//                 { fillStyle: "#F1CB30", textFillStyle: '#ffff', textFontSize: '38', text: "2.5K" },
//                 { fillStyle: "#BDCF71", textFillStyle: '#ffff', textFontSize: '38', text: "250" },
//                 { fillStyle: "#645C9E", textFillStyle: '#ffff', textFontSize: '38', text: "500" },
//                 { fillStyle: "#D06F1E", textFillStyle: '#ffff', textFontSize: '38', text: "10K" },
//                 { fillStyle: "#7D3585", textFillStyle: '#ffff', textFontSize: '38', text: "1K" },
//             ],
//             lineWidth: 0.01,
//             animation: {
//                 type: "spinToStop",
//                 duration: 8,
//                 spins: 10,
//                 callbackFinished: "alertPrize()",
//                 callbackAfter: function () {
//                     alert("dd");
//                 },
//             },
//         });
//     }, []);

//     function calculatePrize() {
//         var stopAt = window.winwheel.getRandomForSegment(5);
//         window.winwheel.animation.stopAngle = stopAt;
//         window.winwheel.startAnimation();
//     }
//     function startSpin() {
//         calculatePrize();
//         setCongratBanner(false);
//         setIsExploding(false);

//         // window.winwheel.startAnimation();
//     }
//     function directWin() {
//         setCongratBanner(true);
//         setIsExploding(true);

//         // window.winwheel.startAnimation();
//     }

//     window.alertPrize = function () {
//         let winningSegment = window.winwheel.getIndicatedSegment();
//         // alert("You have won " + winningSegment.text + "!");
//         setCongratBanner(true);
//         setPoints(winningSegment.text);
//         setIsExploding(true);
//         window.winwheel.stopAnimation(false);
//         window.winwheel.rotationAngle = 0;

//     };

//     setTimeout(() => {
//         setIsExploding(false);
//     }, 4500);




//     function reset() {
//         window.winwheel.stopAnimation(false);
//         window.winwheel.rotationAngle = 0;
//     }

//     function drawTriangle() {
//         if (typeof window.winwheel != "undefined") {
//             // Get the canvas context the wheel uses.
//             let ctx = window.winwheel.ctx;

//             ctx.strokeStyle = "navy"; // Set line colour.
//             ctx.fillStyle = "aqua"; // Set fill colour.
//             ctx.lineWidth = 2;
//             ctx.beginPath(); // Begin path.
//             ctx.moveTo(170, 5); // Move to initial position.
//             ctx.lineTo(230, 5); // Draw lines to make the shape.
//             ctx.lineTo(200, 40);
//             ctx.lineTo(171, 5);
//             ctx.stroke(); // Complete the path by stroking (draw lines).
//             ctx.fill(); // Then fill.
//         }
//     }

//     return (
//         <>
//             {isExploding &&
//                 <ConfettiExplosion
//                     height="2320"
//                     width="2800"
//                     particleCount="800"
//                     duration="4500" />
//             }
//             <div className='sb-accordion-wrapper sb-spin-and-win-accordian'>
//                 <Accordion defaultActiveKey={'0'} alwaysOpen>
//                     <Accordion.Item eventKey="0" key="0">
//                         <Accordion.Header>
//                             <span className="sb-accordion-wrapper__plus"><PlusIcon /></span>
//                         </Accordion.Header>
//                         <Accordion.Body>

//                             <UiCol lg="12">
//                                 <div className='sb-three-tokens-to-play'>
//                                     <div className='sb-three-tokens-to-play__top'>
//                                         <div className='sb-three-tokens-to-play__heading'>
//                                             <RightCircleIcon /> <h4>3 tokens to play</h4>
//                                         </div>
//                                         <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam eu turpis molestie, dictum est a, mattis tellus. Sed dignissim, metus nec fringilla accumsan, risus sem sollicitudin lacus, ut interdum tellus elit sed risus. Maecenas eget condimentum velit, sit amet feugiat lectus. Class aptent taciti sociosqu</p>
//                                     </div>
//                                     <div className='sb-three-tokens-to-play__progress'>
//                                         <ProgressBar now={33} />
//                                     </div>

//                                     <div className='sb-three-tokens-to-play__inputs'>
//                                         <UiSingleRow className="justify-content-center">
//                                             <UiCol lg="4">
//                                                 <div className='sb-three-tokens-to-play__inputs-wr'>
//                                                     <div className='sb-circle-no'>1</div>
//                                                     <UiInput placeholder="Enter token reference" size="60" />
//                                                     <div className='sb-three-tokens-to-play__done-icon'>
//                                                         <CircleRoundedGreen />
//                                                     </div>
//                                                 </div>
//                                             </UiCol>
//                                             <UiCol lg="4">
//                                                 <div className='sb-three-tokens-to-play__inputs-wr'>
//                                                     <div className='sb-circle-no'>2</div>
//                                                     <UiInput placeholder="Enter token reference" size="60" />
//                                                     <div className='sb-three-tokens-to-play__done-icon'>
//                                                         <CircleRoundedGreen />
//                                                     </div>
//                                                 </div>
//                                             </UiCol>
//                                             <UiCol lg="4">
//                                                 <div className='sb-three-tokens-to-play__inputs-wr'>
//                                                     <div className='sb-circle-no'>3</div>
//                                                     <UiInput placeholder="Enter token reference" size="60" />
//                                                     <div className='sb-three-tokens-to-play__done-icon'>
//                                                         <CircleRoundedGreen />
//                                                     </div>
//                                                 </div>
//                                             </UiCol>
//                                         </UiSingleRow>
//                                         <UiSingleRow>
//                                             <UiCol lg="3" className="offset-lg-5 mt-4">
//                                                 {props.spinAndWheel ?
//                                                     <UiButtonSecondary btnName="Start wheel of fun" onClick={startSpin} /> :
//                                                     <UiButtonSecondary btnName="Submit" onClick={directWin} />
//                                                 }

//                                             </UiCol>
//                                         </UiSingleRow>
//                                     </div>

//                                 </div>
//                             </UiCol>

//                             {props.spinAndWheel &&

//                                 <UiCol lg="12" className="mx-auto sb-wheel-main-wr">
//                                     <div id="canvasContainer">
//                                         <div className='sb-wheel-fun-text'>
//                                             <WheelOfFunIcon/>
//                                             {/* <div class="wheel-fun-text inverso">
//                                                 <span>S</span>
//                                                 <span>P</span>
//                                                 <span>I</span>
//                                                 <span>N</span>
//                                                 <span>&</span>
//                                                 <span>W</span>
//                                                 <span>I</span>
//                                                 <span>N</span>
//                                             </div> */}
//                                         </div>
//                                         <canvas id="canvas" width="750" height="550">
//                                             Canvas not supported, please user another browser.
//                                         </canvas>
//                                         <img id="prizePointer" src={Pointer} alt="V" />

//                                     </div>
//                                 </UiCol>
//                             }
//                             {congratBanner &&
//                                 <div className='sb-spin-wheel-sucess-msg'>
//                                     <h3>Congratulations</h3>
//                                     <p>Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Ut enim ad minim veniam, quis nostrud exercitation ullamco.</p>

//                                     {props.spinAndWheel ?
//                                         <div className='sb-spin-wheel-point-bg'>
//                                             {points} Points
//                                         </div> : <div className='sb-spin-wheel-point-bg'>
//                                             30K Points
//                                         </div>}

//                                     {props.spinAndWheel &&
//                                         <div className='sb-spin-wheel-sucess-msg__claim'>
//                                             <h5>Go to shop</h5>
//                                         </div>
//                                     }
//                                 </div>
//                             }

//                         </Accordion.Body>
//                     </Accordion.Item>
//                 </Accordion>
//             </div>
//         </>
//     )
// }


// import React, { useEffect, useState, useRef } from "react";
// import { useSelector, useDispatch } from "react-redux";
// import { Link } from "react-router-dom";
// import * as yup from "yup";
// import { Accordion } from "react-bootstrap";
// import {
//     UiCol,
//     UiSingleRow,
//     UiRowContainer,
// } from "../../../_uiComponents/grid-container/GridContainer";
// import { UiButtonSecondary } from "../../../_uiComponents//form/UiButton";
// import RightCircleIcon from "../../../../styles/img/svg/RightCircleIcon";
// import { UiInput } from "../../../_uiComponents/form/UiInput";
// import ProgressBar from "react-bootstrap/ProgressBar";
// import { WheelOfFunIcon } from "../../../../styles/img/svg/WheelOfFun";
// import Winwheel from "winwheel";
// import Pointer from "../../../../styles/img/wheel-center.png";
// import ConfettiExplosion from "react-confetti-explosion";
// import CircleRoundedGreen from "../../../../styles/img/svg/CircleRoundedGreen";
// import {
//     UiContentWr,
//     UiContentCol,
//     UiContentWheelCol,
// } from "../../../_uiComponents/common/UiPageElements";
// import { Form } from "react-final-form";
// import Validator from "../../../../_helpers/validate.schema";
// import {
//     campaignTokenValidationRequest,
//     campaignSpinwinGetDataRequest,
//     campaignSpinwinGetInitialDataRequest,
//     spinWheelTokenReset,
// } from "../../../../_redux/_actions";
// import { TweenMax } from "gsap";
// import { PlusIcon } from "../../../../styles/img/svg/PlusIcon";
// import WheelIndicator from "../../../../styles/img/wheel-indicator.png";
// import CloseIcon from "../../../../styles/img/close-white-icon.png";


const getRandomColor = () => {
    const colorList = [
        "#F2E205",
        "#CFE3DA",
        "#F1F1F3",
        "#FE8E38",
        "#FD7D56",
        "#F5DCD7",
        "#05F2DB",
        "#FF4171",
        "#0B42FF",
        "#35F29A",
    ];

    return colorList[Math.floor(Math.random() * colorList.length)];
};
function randomColor(brightness) {
    function randomChannel(brightness) {
        var r = 255 - brightness;
        var n = 0 | ((Math.random() * r) + brightness);
        var s = n.toString(16);
        return (s.length == 1) ? '0' + s : s;
    }
    return '#' + randomChannel(brightness) + randomChannel(brightness) + randomChannel(brightness);
}
const createSpinWheel = (segmentsData) => {
    window.winwheel = new Winwheel({
        canvasId: "canvas",
        numSegments: segmentsData.length,
        textMargin: 20,
        // pointerAngle: 271,
        pins: {
            fillStyle: "#E5B449",
            outerRadius: 6,
            strokeStyle: "#fff",
            margin: 2,
            number: segmentsData.length,
            lineWidth: 4,
        },
        segments: segmentsData.map((data) => {
            return {
                fillStyle: randomColor(90),
                textFillStyle: "#43454D",
                textFontSize: "14",
                text: data.rewardName,
                lineWidth: 0.1,
            };
        }),
        // lineWidth: 0.01,
        animation: {
            type: "spinToStop",
            duration: 8,
            spins: 10,
            callbackFinished: "alertPrize()",
            callbackAfter: function () {
                alert("dd");
            },
        },
    });
};

export default function SpinAndWheel(props) {
    const [points, setPoints] = useState(0);
    const [congratBanner, setCongratBanner] = useState(false);
    const [readyToPlay, setReadyToPlay] = useState(true);
    const [play, setPlay] = useState(false);
    const [isExploding, setIsExploding] = useState(false);
    const [tokenForms, setTokenForms] = useState([]);
    const [buttonDisable, setButtonDisable] = useState(false);

    const wheelStopSegment = useRef(0);

    const actionDispatch = useDispatch();

    const { campaignDetails, showWheelOfFunButtonShow, addedTokens } =
        useSelector((state) => {
            return {
                campaignDetails: state.campaign.campaignDetails,
                showWheelOfFunButtonShow:
                    state.campaign.campaignDetails.campaignTokens.reduce(
                        (show, spinwinToken) => {
                            if (show && spinwinToken.validate) {
                                return show;
                            }

                            return false;
                        },
                        true,
                    ),

                addedTokens: state.campaign.campaignDetails.campaignTokens.map(
                    (data) => {
                        return data.token;
                    },
                ),
            };
        });
    //     useEffect(() =>{
    //        let canvas = document.getElementById("canvas");
    // if (canvas.getContext)
    // {
    // let ctx = canvas.getContext('2d');
    // ctx.shadowColor = "black";
    // ctx.shadowBlur = 6;

    // }
    //     })
    useEffect(() => {
        actionDispatch(
            campaignSpinwinGetInitialDataRequest({ id: props.incentiveId }),
        );
    }, []);

    useEffect(() => {
        if (typeof campaignDetails.spinwinData.rewardWon != "undefined") {
            const stopSegment = campaignDetails.spinwinData.rewards.findIndex(
                (obj) => {
                    return (
                        obj.rewardId ==
                        campaignDetails.spinwinData.rewardWon.rewardId
                    );
                },
            );

            wheelStopSegment.current = stopSegment + 1;
            setSuccessView();
        }

        createSpinWheel(campaignDetails.spinwinData.rewards);
    }, [campaignDetails.spinwinData.rewards]);

    function calculatePrize() {
        var stopAt = window.winwheel.getRandomForSegment(
            wheelStopSegment.current,
        );

        window.winwheel.animation.stopAngle = stopAt;
        window.winwheel.startAnimation();
    }

    const setSuccessView = () => {
        calculatePrize();
        setCongratBanner(false);
        setIsExploding(false);
        setButtonDisable(true);
    };

    function startSpin() {
        actionDispatch(
            campaignSpinwinGetDataRequest({
                tokens: campaignDetails.campaignTokens.map(
                    (pinwinToken) => pinwinToken.token,
                ),
                campaignId: props.incentiveId,
                setSuccessView,
            }),
        );
        setReadyToPlay(false);
        setPlay(true);
    }

    window.alertPrize = function () {
        let winningSegment = window.winwheel.getIndicatedSegment();

        setCongratBanner(true);
        setPoints(campaignDetails.spinwinData.rewardWon.rewardName);
        setIsExploding(true);
        setReadyToPlay(false);
        window.winwheel.stopAnimation(false);
        window.winwheel.rotationAngle = 0;
    };

    setTimeout(() => {
        setIsExploding(false);
    }, 4500);

    function directWin() {
        setCongratBanner(true);
        setIsExploding(true);
    }
    const msgClose = () => {
        setCongratBanner(false);
    };
    function reset() {
        tokenForms.forEach((form) => {
            form.reset();
        });
        actionDispatch(spinWheelTokenReset());

        const tokenFields = document.getElementsByClassName("spinwheelTokens");

        // TODO need to use proper
        if (typeof tokenFields[0] != undefined) {
            tokenFields[0].value = "";
        }

        // if(typeof  tokenFields[1] != undefined) {
        //     tokenFields[1].value = "";
        // }

        // if(typeof  tokenFields[2] != undefined) {
        //     tokenFields[2].value = "";
        // }

        // if(typeof  tokenFields[3] != undefined) {
        //     tokenFields[3].value = "";
        // }

        // if(typeof  tokenFields[4] != undefined) {
        //     tokenFields[4].value = "";
        // }



        window.winwheel.rotationAngle = 0;
        setCongratBanner(false);
        setPlay(false);
        setReadyToPlay(true);
        setButtonDisable(false);
    }

    const submitToken = async (values) => {
        actionDispatch(
            campaignTokenValidationRequest({
                token: Object.entries(values)[0][1],
                id: Object.entries(values)[0][0],
                campaignId: props.incentiveId,
            }),
        );
    };

    return (
        <>
            <UiContentWr>
                <UiRowContainer fluid="fluid">
                    <UiCol lg="12">
                        <UiContentWheelCol>
                            {isExploding && (
                                <ConfettiExplosion
                                    height="2320"
                                    width="2800"
                                    particleCount="800"
                                    duration="4500"
                                />
                            )}
                            <div className="sb-accordion-wrapper sb-spin-and-win-accordian">
                                <Accordion defaultActiveKey={"0"} alwaysOpen>
                                    <Accordion.Item eventKey="0" key="0">
                                        <Accordion.Header>
                                            <span className="sb-accordion-wrapper__plus">
                                                <PlusIcon />
                                            </span>
                                        </Accordion.Header>
                                        <Accordion.Body>
                                            <UiCol lg="12">
                                                <div className="sb-three-tokens-to-play">
                                                    <div className="sb-spin-win-top-wr">
                                                        <div className="left-col">
                                                            <div className="sb-three-tokens-to-play__top">
                                                                <div className="sb-three-tokens-to-play__heading">
                                                                    <RightCircleIcon />{" "}
                                                                    <h4>
                                                                        {
                                                                            campaignDetails
                                                                                .campaignTokens
                                                                                .length
                                                                        }{" "}
                                                                        tokens
                                                                        to play
                                                                    </h4>
                                                                </div>
                                                                <p>
                                                                    You're
                                                                    guaranteed a
                                                                    reward with
                                                                    every play
                                                                    of our spin
                                                                    & win game.
                                                                    Simply
                                                                    collect the
                                                                    unique codes
                                                                    as
                                                                    identified
                                                                    within the
                                                                    campaign
                                                                    rules and
                                                                    when you
                                                                    have the
                                                                    correct
                                                                    number to
                                                                    qualify,
                                                                    enter your
                                                                    codes in the
                                                                    fields below
                                                                    and get
                                                                    winning.
                                                                </p>
                                                            </div>

                                                            <div className="sb-three-tokens-to-play__progress">
                                                                <ProgressBar
                                                                    now={
                                                                        (campaignDetails.campaignTokens?.reduce(
                                                                            (
                                                                                progress,
                                                                                token,
                                                                            ) => {
                                                                                if (
                                                                                    token.validate
                                                                                ) {
                                                                                    return (
                                                                                        progress +
                                                                                        1
                                                                                    );
                                                                                }

                                                                                return progress;
                                                                            },
                                                                            0,
                                                                        ) *
                                                                            100) /
                                                                        campaignDetails
                                                                            .campaignTokens
                                                                            .length
                                                                    }
                                                                />
                                                            </div>

                                                            <div className="sb-three-tokens-to-play__inputs">
                                                                <UiSingleRow className="justify-content-center">
                                                                    {campaignDetails.campaignTokens.map(
                                                                        (
                                                                            token,
                                                                            index,
                                                                        ) => {
                                                                            const validateSchema =
                                                                                () =>
                                                                                    yup
                                                                                        .object()
                                                                                        .shape(
                                                                                            {
                                                                                                [token.id]:
                                                                                                    yup
                                                                                                        .string()
                                                                                                        .required(
                                                                                                            "Token is required.",
                                                                                                        ),
                                                                                            },
                                                                                        );

                                                                            const onValidate =
                                                                                async (
                                                                                    values,
                                                                                ) => {
                                                                                    return await Validator(
                                                                                        values,
                                                                                        validateSchema,
                                                                                    );
                                                                                };

                                                                            return (
                                                                                <UiCol
                                                                                    key={
                                                                                        index
                                                                                    }
                                                                                    lg="4"
                                                                                >
                                                                                    <div className="sb-three-tokens-to-play__inputs-wr">
                                                                                        <div className="sb-circle-no">
                                                                                            {index +
                                                                                                1}
                                                                                        </div>
                                                                                        <Form
                                                                                            onSubmit={
                                                                                                submitToken
                                                                                            }
                                                                                            validate={
                                                                                                onValidate
                                                                                            }
                                                                                            render={({
                                                                                                handleSubmit,
                                                                                                hasValidationErrors,
                                                                                                form,
                                                                                            }) => (
                                                                                                <form
                                                                                                    onSubmit={
                                                                                                        validateSchema
                                                                                                    }
                                                                                                >
                                                                                                    <UiInput
                                                                                                        className="spinwheelTokens"
                                                                                                        disabled={
                                                                                                            token.validate
                                                                                                        }
                                                                                                        placeholder="Please type token reference"
                                                                                                        size="60"
                                                                                                        name={
                                                                                                            token.id
                                                                                                        }
                                                                                                        onChange={(
                                                                                                            e,
                                                                                                        ) => {
                                                                                                            if (
                                                                                                                e
                                                                                                                    .target
                                                                                                                    .value
                                                                                                                    .length ==
                                                                                                                10 ||
                                                                                                                e
                                                                                                                    .target
                                                                                                                    .value
                                                                                                                    .length ==
                                                                                                                7
                                                                                                            ) {
                                                                                                                if (
                                                                                                                    !addedTokens.includes(
                                                                                                                        e
                                                                                                                            .target
                                                                                                                            .value,
                                                                                                                    )
                                                                                                                ) {
                                                                                                                    tokenForms.push(
                                                                                                                        form,
                                                                                                                    );
                                                                                                                    setTokenForms(
                                                                                                                        tokenForms,
                                                                                                                    );
                                                                                                                    handleSubmit();
                                                                                                                }
                                                                                                            }
                                                                                                        }}
                                                                                                        onPaste={(
                                                                                                            e,
                                                                                                        ) => {
                                                                                                            setTimeout(
                                                                                                                function () {
                                                                                                                    if (
                                                                                                                        e
                                                                                                                            .target
                                                                                                                            .value
                                                                                                                            .length ==
                                                                                                                        10 ||
                                                                                                                        e
                                                                                                                            .target
                                                                                                                            .value
                                                                                                                            .length ==
                                                                                                                        7
                                                                                                                    ) {
                                                                                                                        if (
                                                                                                                            !addedTokens.includes(
                                                                                                                                e
                                                                                                                                    .target
                                                                                                                                    .value,
                                                                                                                            )
                                                                                                                        ) {
                                                                                                                            tokenForms.push(
                                                                                                                                form,
                                                                                                                            );
                                                                                                                            setTokenForms(
                                                                                                                                tokenForms,
                                                                                                                            );
                                                                                                                            handleSubmit();
                                                                                                                        }
                                                                                                                    }
                                                                                                                },
                                                                                                                10,
                                                                                                            );
                                                                                                        }}
                                                                                                    />
                                                                                                </form>
                                                                                            )}
                                                                                        />

                                                                                        {token.validate && (
                                                                                            <div className="sb-three-tokens-to-play__done-icon">
                                                                                                <CircleRoundedGreen />
                                                                                            </div>
                                                                                        )}
                                                                                    </div>
                                                                                </UiCol>
                                                                            );
                                                                        },
                                                                    )}
                                                                </UiSingleRow>
                                                                <UiSingleRow>
                                                                    <UiCol
                                                                        lg="3"
                                                                        className="offset-lg-5 mt-4 col-11"
                                                                    >
                                                                        {showWheelOfFunButtonShow && (
                                                                            <UiButtonSecondary
                                                                                disabled={
                                                                                    buttonDisable
                                                                                }
                                                                                btnName="Spin Reward Wheel"
                                                                                onClick={
                                                                                    startSpin
                                                                                }
                                                                            />
                                                                        )}
                                                                    </UiCol>
                                                                </UiSingleRow>
                                                            </div>
                                                        </div>

                                                        <div className="right-col">
                                                            <UiCol
                                                                lg="12"
                                                                className="mx-auto sb-wheel-main-wr"
                                                            >
                                                                <div id="canvasContainer">
                                                                    <div className="sb-wheel-fun-text">
                                                                        <WheelOfFunIcon />
                                                                    </div>
                                                                    <img
                                                                        src={
                                                                            WheelIndicator
                                                                        }
                                                                        alt="V"
                                                                        className="sb-wheel-indicator-arrow"
                                                                    />
                                                                    {/* <span className="sb-wheel-indicator"><img src={WheelIndicator}/></span>  */}
                                                                    <div className="sb-shadow-circle"></div>
                                                                    <canvas
                                                                        id="canvas"
                                                                        width="800"
                                                                        height="620"
                                                                    >
                                                                        Canvas
                                                                        not
                                                                        supported,
                                                                        please
                                                                        user
                                                                        another
                                                                        browser.
                                                                    </canvas>

                                                                    <img
                                                                        id="prizePointer"
                                                                        src={
                                                                            Pointer
                                                                        }
                                                                        alt="V"
                                                                    />
                                                                </div>
                                                            </UiCol>
                                                        </div>
                                                    </div>
                                                </div>
                                            </UiCol>

                                            {showWheelOfFunButtonShow && !congratBanner ? (
                                                <div className="sb-spin-wheel-sucess-msg">
                                                    <h3>Play</h3>

                                                    <p>
                                                        Rewards are secured for
                                                        you as soon as the game
                                                        play concludes. If
                                                        you've won a value in
                                                        points, head over to the
                                                        Points Banking page to
                                                        check your reward or go
                                                        straight to Shop and
                                                        start spending. ENJOY
                                                        YOUR WELL-EARNED
                                                        REWARDS!
                                                    </p>
                                                    <div className="sb-spin-wheel-point-bg"></div>
                                                </div>
                                            ) : ''}
                                                {!showWheelOfFunButtonShow && !congratBanner ? (
                                                <div className="sb-spin-wheel-sucess-msg">
                                                    <h3>Ready To Play</h3>

                                                    <p>
                                                        Rewards are secured for
                                                        you as soon as the game
                                                        play concludes. If
                                                        you've won a value in
                                                        points, head over to the
                                                        Points Banking page to
                                                        check your reward or go
                                                        straight to Shop and
                                                        start spending. ENJOY
                                                        YOUR WELL-EARNED
                                                        REWARDS!
                                                    </p>
                                                     <div className="sb-spin-wheel-point-bg">


                                                    </div> 
                                                    
                                                </div>) :""}

                                            {congratBanner && (
                                                <div className="sb-spin-wheel-sucess-msg">
                                                    <h3>Congratulations</h3>
                                                    <p>
                                                        Rewards are secured for
                                                        you as soon as the game
                                                        play concludes. If
                                                        you've won a value in
                                                        points, head over to the
                                                        Points Banking page to
                                                        check your reward or go
                                                        straight to Shop and
                                                        start spending. ENJOY
                                                        YOUR WELL-EARNED
                                                        REWARDS!
                                                    </p>
                                                    
                                                    {props.spinAndWheel ? (
                                                        <div className="sb-spin-wheel-point-bg">
                                                            <div className="sb-spin-wheel-point-bg__content">
                                                                <h6>Your voucher is in your Wallet</h6>

                                                            </div>
                                                            {points}
                                                        </div>
                                                    ) : (
                                                        <div className="sb-spin-wheel-point-bg">
                                                            30K Points
                                                        </div>
                                                    )}

                                                    {props.spinAndWheel && (
                                                        <div className="sb-spin-wheel-sucess-msg__claim">
                                                            <Link
                                                                to={
                                                                    "/app/points-banking"
                                                                }
                                                            >
                                                                Check my Points Balance
                                                            </Link>
                                                            <h4 onClick={reset}>
                                                                Reset
                                                            </h4>
                                                        </div>
                                                    )}
                                                </div>
                                            )}
                                            {/* {congratBanner && (
                                                <div className="sb-spin-win-mobile-msg">
                                                    <img
                                                        src={CloseIcon}
                                                        onClick={msgClose}
                                                    />
                                                    <h3>Congratulations</h3>
                                                    <span>You've won</span>
                                                    {props.spinAndWheel ? (
                                                        <div className="sb-spin-wheel-point-bg">
                                                            {points}
                                                        </div>
                                                    ) : (
                                                        <div className="sb-spin-wheel-point-bg">
                                                            30K Points
                                                        </div>
                                                    )}
                                                </div>
                                            )} */}
                                        </Accordion.Body>
                                    </Accordion.Item>
                                </Accordion>
                            </div>
                        </UiContentWheelCol>
                    </UiCol>
                </UiRowContainer>
            </UiContentWr>
        </>
    );
}
